import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { es_ES, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { FormsModule } from '@angular/forms';
import { importProvidersFrom } from '@angular/core';
import {
  ApartmentOutline,
  AppstoreOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  CopyOutline,
  DeleteOutline,
  DesktopOutline,
  EditOutline,
  EyeOutline,
  LineChartOutline,
  LinkOutline,
  LogoutOutline,
  PlusOutline,
  ReloadOutline,
  RocketOutline,
  SaveOutline,
  ThunderboltOutline,
  UploadOutline,
  UserOutline,
} from '@ant-design/icons-angular/icons';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';

registerLocaleData(es);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideNzI18n(es_ES),
    provideNzIcons([
      ApartmentOutline,
      AppstoreOutline,
      ArrowLeftOutline,
      ArrowRightOutline,
      CopyOutline,
      DeleteOutline,
      DesktopOutline,
      EditOutline,
      EyeOutline,
      LineChartOutline,
      LinkOutline,
      LogoutOutline,
      PlusOutline,
      ReloadOutline,
      RocketOutline,
      SaveOutline,
      ThunderboltOutline,
      UploadOutline,
      UserOutline,
    ]),
    importProvidersFrom(FormsModule),
  ],
};
